/**
 * Fixed headings, labels and images for the Contentful product-category pages (`/<slug>`),
 * rendered by `components/Contentful/Product.tsx`. The section copy comes from the Contentful
 * entry, except the What Our Customers Say carousel
 * (`components/Shared/WhatOurCustomers/RefactorContent.tsx`). The sub-category pages read the
 * parallel `./subCategoryStaticContent.ts`. Not a page module: no `MetaObject` or `PageContent`,
 * and not in the site search index. The dormant Southern Tool Steel build uses it too, despite
 * the `ryerson` folder.
 */
import { StaticApplicationsContent } from "@components/Products/Applications";
import { StaticByTheNumbers } from "@components/Products/ByTheNumbers";
import { StaticCharacteristicsContent } from "@components/Products/Characteristics";
import { HeroStaticContent } from "@components/Products/Hero";
import { LanguageContent } from "@ryerson/frontend.common";

/** Hero labels; the button goes to `/store`. */
export const StaticHeroContent: LanguageContent<HeroStaticContent> = {
	en: {
		buttonLabel: "Help me find the right metal",
		buttonActionUrl: "/store",
		productsLabel: "Products",
		referenceTitle: "General Reference",
	},
	fr: {
		buttonLabel: "Aidez-moi à trouver le bon métal",
		buttonActionUrl: "/store",
		productsLabel: "Produits",
		referenceTitle: "Référence Générale",
	},
	es: {
		buttonLabel: "Ayúdame a encontrar el metal adecuado",
		buttonActionUrl: "/store",
		productsLabel: "Productos",
		referenceTitle: "Referencia General",
	},
};

/** Applications section heading, nav label and icon. */
export const ApplicationsStaticContent: LanguageContent<StaticApplicationsContent> = {
	en: {
		title: "Applications",
		navLabel: "Applications",
		icon: "gear",
	},
	fr: {
		title: "Applications",
		navLabel: "Applications",
		icon: "gear",
	},
	es: {
		title: "Aplicaciones",
		navLabel: "Aplicaciones",
		icon: "gear",
	},
};

/**
 * Characteristics & Properties title words, nav label and the two images every card shares. No
 * `gradeTableHeadings`, so category pages show no grade table.
 */
export const CharacteristicsStaticContent: LanguageContent<StaticCharacteristicsContent> = {
	en: {
		title1: "Characteristics",
		title2: "& Properties",
		navLabel: "Characteristics and Properties",
		desktopImage: "/images/products/CharacteristicsPropertiesDesktop.jpg",
		mobileImage: "/images/products/CharacteristicsPropertiesMobile.jpg",
	},
	fr: {
		title1: "Caractéristiques",
		title2: " et propriétés",
		navLabel: "Caractéristiques et propriétés ",
		desktopImage: "/images/products/CharacteristicsPropertiesDesktop.jpg",
		mobileImage: "/images/products/CharacteristicsPropertiesMobile.jpg",
	},
	es: {
		title1: "Características",
		title2: " y Propiedades",
		navLabel: "Características y Propiedades",
		desktopImage: "/images/products/CharacteristicsPropertiesDesktop.jpg",
		mobileImage: "/images/products/CharacteristicsPropertiesMobile.jpg",
	},
};

/** By The Numbers section heading and nav label. */
export const ByTheNumbersStaticContent: LanguageContent<StaticByTheNumbers> = {
	en: {
		title: "By The Numbers",
		navLabel: "By The Numbers",
	},
	fr: {
		title: "Par les nombres",
		navLabel: "Par les nombres",
	},
	es: {
		title: "Por los números",
		navLabel: "Por los números",
	},
};
